import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import { RenglonSemaforo } from "../RenglonSemaforo";
import { TituloSemaforo } from "../TituloSemaforo";

export const PorCerrarServicio = ({ asistenciasSemaforo }) => {
  const asistencias = asistenciasSemaforo.filter((a) => a.estatusID === 5);
  return (
    <section className="semaforo-general__columna" aria-label="Por cerrar servicio">
      <TituloSemaforo icon={<CheckOutlined />} titulo="Arribado - En trayecto a concluir" count={asistencias.length} />
      {asistencias.length === 0 && <p className="semaforo-general__vacio">Sin asistencias por cerrar</p>}
      {asistencias.map((a) => (
        <RenglonSemaforo key={a.asistenciaID} asistencia={a} fecha={a.fechaContacto} />
      ))}
    </section>
  );
};
